import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

const testimonials = [
  {
    quote: "Efficient, cost-effective, and reliable service. Libros consistently delivers on time without compromising on quality.",
    author: "Editorial Director",
    org: "Independent Publishing House",
    accent: "#1F5EFF",
  },
  {
    quote: "Excellent quality with outstanding turnaround time. Their accessibility expertise is second to none.",
    author: "Head of Production",
    org: "Educational Press",
    accent: "#6D28D9",
  },
  {
    quote: "A trusted partner for digital publishing and accessibility. They feel like an extension of our own team.",
    author: "Digital Publishing Lead",
    org: "Global Imprint",
    accent: "#00B8A9",
  },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="relative py-24 sm:py-32 bg-[#F8FAFC]">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl mb-12">
          <div className="overline">What Our Clients Say</div>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0B1F3A] tracking-tighter leading-[1.08]">
            Trusted partnerships. Proven results.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {testimonials.map((t, i) => (
            <motion.figure
              key={i}
              data-testid={`testimonial-card-${i}`}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="lift-card relative rounded-3xl bg-white border border-[#0B1F3A]/10 p-8 sm:p-9"
            >
              <div
                className="inline-flex h-11 w-11 items-center justify-center rounded-2xl mb-6"
                style={{ backgroundColor: `${t.accent}14`, color: t.accent }}
              >
                <Quote className="h-5 w-5" />
              </div>
              <blockquote className="font-display text-lg sm:text-xl text-[#0B1F3A] leading-relaxed">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <div className="mt-7 flex items-center gap-2" role="img" aria-label="Rated 5 out of 5 stars">
                {Array.from({ length: 5 }).map((_, j) => (
                  <Star key={j} aria-hidden="true" className="h-3.5 w-3.5 fill-[#1F5EFF] text-[#1F5EFF]" />
                ))}
              </div>
              <figcaption className="mt-4">
                <div className="font-semibold text-[14px] text-[#0B1F3A]">{t.author}</div>
                <div className="text-[13px] text-[#475569]">{t.org}</div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
